function componentTracking() {
    // add "data-brand=[brand name]"
    // add "data-element=[Image|Text Link|Button]"
    // add "data-component=[PROVIDER CARD | PROVIDERS TABLE | BODY | HERO | FOOTER]"

    $(document).ready(() => {
        // add Hero component to elements with hero class for old pages
        $(
            '.hero, .bg-city, .main-content > .row > .columns > .bg-secondary-xdark:first'
        ).attr('data-component', 'Hero');

        const components = document.querySelectorAll('[data-component]');

        for (let i = 0; i < components.length; i++) {
            const component = components[i];
            const componentType = component.getAttribute('data-component');
            let componentBrand = component.getAttribute('data-brand');

            if (componentBrand === 'Xfinity') {
                componentBrand = 'Comcast';
            }

            const links = component.getElementsByTagName('a');

            const zipForms = component.getElementsByClassName('zip-finder');

            // add component type to zip form buttons
            for (let z = 0; z < zipForms.length; z++) {
                const submitButton = zipForms[z].querySelector(
                    'button[type="submit"]'
                );
                if (submitButton) {
                    submitButton.setAttribute('data-component', componentType);
                }
            }

            // loop over all links
            for (let x = 0; x < links.length; x++) {
                const link = links[x];

                if (link.hasAttribute('href')) {
                    link.setAttribute('data-component', componentType);

                    // specifically rewrite Comcast
                    if (componentBrand === 'Comcast') {
                        link.setAttribute('data-brand', componentBrand);
                    }

                    // set Brand if not from link
                    if (!link.getAttribute('data-brand') && componentBrand) {
                        link.setAttribute('data-brand', componentBrand);
                    }

                    // Set link type
                    if (!link.hasAttribute('data-element')) {
                        if (
                            link.getElementsByTagName('button')[0] ||
                            link.classList.contains('button')
                        ) {
                            // buttons
                            link.dataset.element = 'Button';
                        } else if (link.getElementsByTagName('img')[0]) {
                            // images, logos, etc
                            // Logos
                            link.dataset.element = 'Image';
                        } else {
                            // default is text
                            link.dataset.element = 'Text Link';
                        }
                    }
                }
            }
        }
    });
}

function linkTracking() {
    $(document).ready(() => {
        // loop over links and set data brand if appropriate
        const links = document.querySelectorAll('a');

        for (let i = 0; i < links.length; i++) {
            const link = links[i];

            if (link.hasAttribute('href')) {
                const linkhref = link.getAttribute('href');

                // look for go links
                if (linkhref.includes('/go/')) {
                    if (!link.dataset.element) {
                        if (
                            link.getElementsByTagName('button')[0] ||
                            link.classList.contains('button')
                        ) {
                            link.dataset.element = 'Button';
                        } else if (link.querySelector('img') !== null) {
                            link.dataset.element = 'Image';
                        } else {
                            link.dataset.element = 'Text Link';
                        }
                    }
                }
            }
        }
    });
}

export { componentTracking, linkTracking };
